export default __webpack_public_path__ + "static/media/logo_big.32473d9a.png";